import { supabase } from "@/integrations/supabase/client";
import type { Achievement } from "./victoryAchievements";

export type SharePlatform = "whatsapp" | "instagram" | "tiktok" | "native_share" | "download";

export async function recordShare(opts: {
  achievement: Achievement;
  platform: SharePlatform;
  nationCode: string | null;
}): Promise<void> {
  const { data: auth } = await supabase.auth.getUser();
  if (!auth.user) return;
  const { error } = await supabase.from("victory_card_shares").insert({
    user_id: auth.user.id,
    achievement_type: opts.achievement.type,
    achievement_payload: JSON.parse(
      JSON.stringify({ id: opts.achievement.id, headline: opts.achievement.headline, ...opts.achievement.payload }),
    ),
    platform: opts.platform,
    nation_code: opts.nationCode,
  });
  if (error) console.warn("[victory-shares] insert failed", error.message);
}
